// front/src/components/layout/Sidebar/Sidebar.jsx
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SidebarContainer, MenuItem, SubMenu, MenuText } from './Sidebar.styles';

const Sidebar = ({ 
  items = [], 
  collapsed = false, 
  onToggleCollapse,
  className = '' 
}) => {
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState({});

  useEffect(() => {
    const newExpanded = {};

    items.forEach(item => {
      const isParentRoute = item.path === location.pathname;
      const isSubItemRoute = item.subItems?.some(
        subItem => subItem.path === location.pathname
      );

      if (isParentRoute || isSubItemRoute) {
        newExpanded[item.key] = true;
      }
    });

    setExpandedItems(newExpanded);
  }, [items, location.pathname]);

  const toggleSubMenu = (itemKey) => {
    setExpandedItems(prev => ({
      ...prev,
      [itemKey]: !prev[itemKey]
    }));
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const renderIcon = (item) => {
    if (!item.icon) return null;
    if (item.iconType === 'image') {
      return <img src={item.icon} alt="" className="sidebar-custom-icon" />;
    }
    if (typeof item.icon === 'string') {
      return <span className="material-symbols-outlined">{item.icon}</span>;
    }
    return null;
  };

  const renderMenuItem = (item, level = 0) => {
    const hasSubItems = item.subItems && item.subItems.length > 0;
    const isExpanded = expandedItems[item.key];
    const isItemActive = isActive(item.path);
    const isDisabled = item.disabled === true;

    return (
      <div key={item.key}>
        {hasSubItems ? (
          isDisabled ? (
            <MenuItem
              level={level}
              active={isItemActive}
              collapsed={collapsed}
              disabled={isDisabled}
            >
              {renderIcon(item)}
              {!collapsed && <MenuText>{item.label}</MenuText>}
            </MenuItem>
          ) : item.path ? (
            <Link 
              to={item.path} 
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <MenuItem
                level={level}
                onClick={() => toggleSubMenu(item.key)}
                active={isItemActive}
                collapsed={collapsed}
                disabled={isDisabled}
              >
                {renderIcon(item)}
                {!collapsed && <MenuText>{item.label}</MenuText>}
              </MenuItem>
            </Link>
          ) : (
            <MenuItem
              level={level}
              onClick={() => toggleSubMenu(item.key)}
              active={isItemActive}
              collapsed={collapsed}
              disabled={isDisabled}
            >
              {renderIcon(item)}
              {!collapsed && <MenuText>{item.label}</MenuText>}
            </MenuItem>
          )
        ) : (
          isDisabled ? (
            <MenuItem
              level={level}
              active={isItemActive}
              collapsed={collapsed}
              disabled={isDisabled}
            >
              {renderIcon(item)}
              {!collapsed && <MenuText>{item.label}</MenuText>}
            </MenuItem>
          ) : (
            <Link to={item.path} style={{ textDecoration: 'none', color: 'inherit' }}>
              <MenuItem
                level={level}
                active={isItemActive}
                collapsed={collapsed}
                disabled={isDisabled}
              >
                {renderIcon(item)}
                {!collapsed && <MenuText>{item.label}</MenuText>}
              </MenuItem>
            </Link>
          )
        )}

        {hasSubItems && !collapsed && (
          <SubMenu isVisible={isExpanded}>
            {item.subItems.map(subItem => renderMenuItem(subItem, level + 1))}
          </SubMenu>
        )}
      </div>
    );
  };

  return (
    <SidebarContainer collapsed={collapsed} className={className}>
      {items.map(item => renderMenuItem(item))}
    </SidebarContainer>
  );
};

export default Sidebar;
